import { getKeywordSearchFacilities } from 'assets/modules/graphs';
import { selectNodeThroughSearch } from 'discover/modules/viz';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useMixpanel from 'utils/hooks/Mixpanel';

const { AutoComplete } = require('common/components/AutoComplete');

const AssetSearchBar = props => {
  const [options, setOptions] = useState([]);
  const [keyword, setKeyword] = useState('');
  const { search_facilities: searchFacilities } = useSelector(state => state.graphs);
  const selectedNode = useSelector(state => state.networkGraph?.selectedNode);
  const dispatch = useDispatch();
  const mixpanelTrack = useMixpanel();

  useEffect(() => {
    if (selectedNode?.name === keyword) return;
    setOptions(
      (searchFacilities ?? [])
        .filter(facility => (keyword ? facility.name?.toUpperCase().includes(keyword.toUpperCase()) : false))
        .map(facility => {
          let start = facility.name.toUpperCase().indexOf(keyword.toUpperCase());
          if (start < 0) {
            return { value: facility.name, id: facility.id, label: facility.name };
          }
          return {
            value: facility.name,
            id: facility.id,
            label: (
              <>
                {facility.name.substring(0, start)}
                <span className="search-hit">{facility.name.substring(start, start + keyword.length)}</span>
                {facility.name.substring(start + keyword.length)}
              </>
            ),
          };
        }),
    );
  }, [searchFacilities, keyword, selectedNode]);

  useEffect(() => {
    setKeyword(selectedNode?.name || '');
  }, [selectedNode]);

  const debounceSearchHandler = _.debounce(keyword => {
    if (
      keyword &&
      !(searchFacilities ?? []).filter(facility => facility.name?.toUpperCase().includes(keyword.toUpperCase())).length
    ) {
      dispatch(getKeywordSearchFacilities(keyword));
    }
  }, 500);

  const handleChange = val => {
    setKeyword(val);
  };

  const handleSelect = (val, option) => {
    mixpanelTrack('Network button view - Search');
    dispatch(selectNodeThroughSearch(option.id));
  };

  return (
    <AutoComplete
      className={props.className}
      placeholder="Search facilities"
      value={keyword}
      options={options}
      onSearch={debounceSearchHandler}
      onChange={handleChange}
      onSelect={handleSelect}
    />
  );
};

export default AssetSearchBar;
